"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgCameraFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M4 6.003c1.341.002 2.678.002 4.011 0l.631-1.266c.102-.262.247-.454.433-.574a1.1 1.1 0 01.675-.16h4.475c.263-.017.491.036.685.16.195.123.349.315.463.574l.62 1.266c1.338.003 2.674.003 4.007 0C21.333 6 22 6.666 22 8v10c0 1.338-.667 2.006-2 2.003-2-.004-13.989-.004-16 0-1.34.003-2.008-.665-2-2.003V8c-.008-1.333.66-1.998 2-1.997zm8 12a5 5 0 100-10 5 5 0 000 10zm0-2a3 3 0 110-6 3 3 0 010 6z' }))); };
exports.default = SvgCameraFilled;
//# sourceMappingURL=CameraFilled.js.map